<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { formatTime } from '@/utils/datetime'
import { getBaseUrl } from '@/utils/url'

import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { ShoppingCart } from 'lucide-vue-next'

import PreviewItemShape from './PreviewItemShape.vue'

const emit = defineEmits(['select'])
const props = defineProps({
  userFeature: {
    type: Object,
    required: true
  },
  feature: {
    type: Object,
    required: true
  },
  orgId: {
    type: String,
    required: true
  },
  map: {
    type: Object,
    required: true
  },
  isOrdering: {
    type: Boolean,
    default: false
  },
  selected: {
    type: Boolean,
    default: false
  }
})

const store = useStore()
const settings = computed(() => store.getters['user/getUserSettings'])
const internalSelected = ref(false)

const host = getBaseUrl()
const previewUrl = `${host}/tulum/search/thumb/${props.orgId}/${props.feature.properties.item_type}/${props.feature.id}?token=${props.token}`

const dateFormated = computed(() => {
  return formatTime(props.feature.properties.acquired, settings.value.tz,'D MMMM YYYY')
})

const isSelected = computed(() => props.selected !== undefined ? props.selected : internalSelected.value)

const select = (event) => {
  const newValue = !isSelected.value
  internalSelected.value = newValue
  emit('select', newValue, event)
}
</script>

<template>
  <div
    class="mb-3 rounded border space-y-3 transition-all"
    :class="[
      isSelected ? 'border-primary bg-primary/5' : 'border-gray-200'
    ]"
  >
    <div class="flex space-x-3 p-2 m-0">
      <div v-if="!isOrdering" class="flex items-center">
        <Checkbox
          :model-value="isSelected"
          @update:model-value="select($event)"
        />
      </div>
      <div @click.stop>
        <PreviewItemShape
          :scene-feature="feature"
          :user-geometry="userFeature.geometry"
          :image-url="previewUrl"
          :map="map"
        />
      </div>
      <div class="flex-1">
        <h2 class="font-bold mb-1">{{  dateFormated }}</h2>
        <div>
          <p class="flex justify-between"><span>Type:</span> {{ feature.properties.item_type }}</p>
          <p class="flex justify-between"><span>Cloud Cover:</span> {{ feature.properties.cloud_cover }}%</p>
          <p class="flex justify-between"><span>Clear Confidence:</span> {{ feature.properties.clear_confidence_percent }}%</p>
          <p class="flex justify-between"><span>Pixel Resolution:</span> {{ feature.properties.pixel_resolution }}m/px</p>
        </div>
      </div>
    </div>

    <!-- <div class="mb-3">
      <p><span class="font-medium">ID:</span> {{ feature.id }}</p>
      <p><span class="font-medium">Acquired:</span> {{ feature.properties.acquired }}</p>
      <p><span class="font-medium">Published:</span> {{ feature.properties.published }}</p>
      <p><span class="font-medium">Updated:</span> {{ feature.properties.updated }}</p>
      <p><span class="font-medium">Satellite ID:</span> {{ feature.properties.satellite_id }}</p>
    </div> -->
  </div>
</template>
